import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./PrivacyPolicy.css";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-page">
      <button className="back-btn" onClick={() => navigate('/')}>
        <FaArrowLeft />
      </button>

      <h1>About Us</h1>

      <h2>Unlock Deals. Earn Gold. Shop Smarter with Discount Dost.</h2>
      <p>
        India’s friendliest savings app — discover amazing deals at your favorite stores and earn real gold on every spend.
      </p>

      <h2>Why Choose Discount Dost?</h2>
      <p>
        <strong>Your Trusted Dost for Discounts, Rewards & Real Gold</strong><br />
        At Discount Dost, every purchase is more than just savings — it’s an opportunity to earn real value.
        Whether it’s a coffee break, a quick salon visit, or your weekly grocery haul, we’ve teamed up with your favorite
        local stores to offer amazing deals and digital gold rewards.
      </p>

      <h2>How It Works – Just 3 Simple Steps</h2>
      <ol>
        <li><strong>Discover Deals Nearby:</strong> Explore exclusive discounts at restaurants, salons, gyms, and more — all in your neighborhood.</li>
        <li><strong>Pay & Save Instantly:</strong> Use Discount Dost at checkout to unlock instant savings — no hassle, no hidden fees.</li>
        <li><strong>Earn Digital Gold:</strong> With every transaction, collect digital gold in your wallet. Save it, stack it, or redeem it for real 24K gold.</li>
      </ol>

      <h2>What Sets Us Apart?</h2>
      <ul>
        <li><strong>Real Gold Rewards:</strong> Every transaction brings you closer to owning actual 24K gold — not just points or cashback.</li>
        <li><strong>Local Love:</strong> We handpick deals from Indian stores — supporting homegrown businesses online and offline.</li>
        <li><strong>Transparent & Free:</strong> No subscriptions. No hidden charges. Just genuine savings.</li>
        <li><strong>Fun, Gamified Experience:</strong> Rise through the ranks:
          <ul>
            <li>Casual Dost → Smart Dost → Gold Dost</li>
            <li>Each tier unlocks more rewards and benefits.</li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default About;
